<ion-header id="primary-header">
  <tidy-wrapper
    class="primary-menu overflow-container"
    [isMenu]="true"
    id="primary-menu">

    <!-- User Profile Section -->
    <div class="user-profile-section">
      <div class="user-profile-content">
        <div class="user-info" (click)="toggleUserDropdown($event)" #userIconRef>
          <div class="user-initials">{{initials || 'P'}}</div>
          <tidy-text [navTitle]="userName || 'Pro'" class="user-name"></tidy-text>
          <img src="assets/svg/chevron-down-outline.svg" class="dropdown-arrow" />
        </div>
      </div>
    </div>

    @if (showUserDropdown) {
      <div #userDropdownRef class="user-dropdown">
        <div class="user-dropdown-list">
          <div class="user-dropdown-item" (click)="goToSettings()">
            <tidy-text [body]="'Settings'"></tidy-text>
          </div>
          <div class="user-dropdown-item" (click)="logout()">
            <tidy-text [body]="'Logout'"></tidy-text>
          </div>
        </div>
      </div>
    }

    <!-- Menu items -->
    <div style="margin-top: 5px; padding: 0 5px 0 0;">
      @for (item of menuItems; track item.target) {
        <tidy-card-button
          [hideArrow]="true"
          class="fix-button-padding nav-menu-item nav-menu-item-small"
          [class.current-item]="isCurrentItem(item)"
          (click)="goToLink(item.target)"
          button
          style="height: 38px; display: flex; justify-content: flex-start; align-items: center;">
          <div style="padding: 8px 8px 8px 0px; display: flex; align-items: center; justify-content: flex-start; width: 100%;">
            <div style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; position: relative; background-color: transparent; border: none;">
              <tidy-image
                [src]="(isCurrentItem(item) ? item.activeIcon : item.icon)"
                style="width: 16px; height: 16px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2;"></tidy-image>
            </div>
            <tidy-text [body]="item.label" class="white nav-item-label-small"></tidy-text>
          </div>
        </tidy-card-button>
      }

      <!-- Help dropdown section -->
      <div class="section-dropdown more-section">
        <div class="section-dropdown-header" (click)="toggleHelpMenu($event)">
          <tidy-text [body]="'Help'" class="section-label"></tidy-text>
          <img
            src="assets/svg/chevron-down-outline.svg"
            class="section-dropdown-arrow"
            [class.expanded]="helpMenuExpanded" />
        </div>
        @if (helpMenuExpanded) {
          <div class="section-dropdown-items">
            <tidy-card-button
              [hideArrow]="true"
              class="fix-button-padding nav-menu-item nav-menu-item-small"
              (click)="openWhatsNew()"
              button
              style="height: 38px; display: flex; justify-content: flex-start; align-items: center;">
              <div style="padding: 8px 8px 8px 0px; display: flex; align-items: center; justify-content: flex-start; width: 100%;">
                <div style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; position: relative; background-color: transparent; border: none;">
                  <tidy-image
                    [src]="'assets/svg/information-circle-outline.svg'"
                    style="width: 16px; height: 16px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2;"></tidy-image>
                </div>
                <tidy-text [body]="'What\'s New?'" class="white nav-item-label-small"></tidy-text>
              </div>
            </tidy-card-button>
            <tidy-card-button
              [hideArrow]="true"
              class="fix-button-padding nav-menu-item nav-menu-item-small"
              (click)="openDocumentation()"
              button
              style="height: 38px; display: flex; justify-content: flex-start; align-items: center;">
              <div style="padding: 8px 8px 8px 0px; display: flex; align-items: center; justify-content: flex-start; width: 100%;">
                <div style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; position: relative; background-color: transparent; border: none;">
                  <tidy-image
                    [src]="'assets/svg/book-outline.svg'"
                    style="width: 16px; height: 16px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2;"></tidy-image>
                </div>
                <tidy-text [body]="'Documentation'" class="white nav-item-label-small"></tidy-text>
              </div>
            </tidy-card-button>
            <tidy-card-button
              [hideArrow]="true"
              class="fix-button-padding nav-menu-item nav-menu-item-small"
              (click)="openContactSupport()"
              button
              style="height: 38px; display: flex; justify-content: flex-start; align-items: center;">
              <div style="padding: 8px 8px 8px 0px; display: flex; align-items: center; justify-content: flex-start; width: 100%;">
                <div style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; position: relative; background-color: transparent; border: none;">
                  <tidy-image
                    [src]="'assets/svg/ellipsis-horizontal-outline.svg'"
                    style="width: 16px; height: 16px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2;"></tidy-image>
                </div>
                <tidy-text [body]="'Contact Support'" class="white nav-item-label-small"></tidy-text>
              </div>
            </tidy-card-button>
            <tidy-card-button
              [hideArrow]="true"
              class="fix-button-padding nav-menu-item nav-menu-item-small"
              (click)="openTerms()"
              button
              style="height: 38px; display: flex; justify-content: flex-start; align-items: center;">
              <div style="padding: 8px 8px 8px 0px; display: flex; align-items: center; justify-content: flex-start; width: 100%;">
                <div style="width: 24px; height: 24px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; position: relative; background-color: transparent; border: none;">
                  <tidy-image
                    [src]="'assets/svg/document-text-outline.svg'"
                    style="width: 16px; height: 16px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 2;"></tidy-image>
                </div>
                <tidy-text [body]="'Terms'" class="white nav-item-label-small"></tidy-text>
              </div>
            </tidy-card-button>
          </div>
        }
      </div>
    </div>

    <!-- Theme toggle (always at very bottom) -->
    <div class="theme-toggle" (click)="themeService.toggleTheme()">
      <tidy-image
        [src]="themeService.isDarkMode() ? 'assets/svg/sunny-outline.svg' : 'assets/svg/moon-outline.svg'"
        style="width: 16px; height: 16px;"></tidy-image>
      <tidy-text [body]="themeService.isDarkMode() ? 'Light Mode' : 'Dark Mode'" class="white nav-item-label-small"></tidy-text>
    </div>

  </tidy-wrapper>
</ion-header>
